<div class="info--page container">
  <h1 class="InfoPage__Title" [innerHTML]="config?.header?.title"></h1>
  <p>{{ config?.header?.subtitle }}</p>

  <div class="container workflow-step__cards">
    <section class="card workflow-step__card">
      @for (card of config.cards; track card) {
        <section class="workflow-step__card__body workflow-step__control-group">
          @for (section of card.sections; track section) {
            <div class="workflow-step__card__section">
              @if (section.type === 'header') {
                <h2 class="workflow-step__control-group__header t-bold">
                  {{ section.text }}
                </h2>
              }
              @if (section.type === 'text') {
                <p class="t-data" [innerHTML]="section.text"></p>
              }
              @if (section.type === 'list') {
                <ul>
                  @for (item of section.items; track item) {
                    <li
                      class="t-data workflow-step__control-group--list-item"
                      [innerHTML]="item"
                    ></li>
                  }
                </ul>
              }
            </div>
          }
        </section>
      }
    </section>
  </div>
</div>

@if (config?.footer) {
  <div
    class="info--page__footer"
    [ngClass]="config?.footer?.sticky ? 'sticky' : 'fixed'"
  >
    <div class="container">
      <div class="u-flex u-justifyEnd">
        @for (button of config?.footer.buttons; track button) {
          <zip-button
            [level]="button.level"
            (zipButtonClicked)="close.emit()"
            [content]="button.content"
          >
          </zip-button>
        }
      </div>
    </div>
  </div>
}
